// extracted by mini-css-extract-plugin
export default {"widthInput":"form-section-references_widthInput__QU5Y9"};